import outlookIcon from '../img/outlook.png'

const OpenOutlookIcon = () => (
    <img src={outlookIcon} alt="" width={14} height={14} aria-hidden />
)

export default OpenOutlookIcon
